module.exports = __webpack_public_path__ + "static/6-3fc8adbbbf28d254b65a7ca749e329d5.jpg";